import {
  BitplotActionConstants,
  GET_BP_USER_HOME_DATA,
  GET_BP_USER_HOME_DATA_SUCCESS,
  GET_BP_USER_HOME_DATA_FAILED,
  GET_BP_USER_SETTINGS,
  GET_BP_USER_SETTINGS_SUCCESS,
  GET_BP_USER_SETTINGS_FAILED,
  BUY_LAND_ASSET,
  BUY_LAND_ASSET_SUCCESS,
  BUY_LAND_ASSET_FAILED,
  GET_USER_LAND_ASSETS,
  GET_USER_LAND_ASSETS_SUCCESS,
  GET_USER_LAND_ASSETS_FAILED,
  GET_INDIVIDUAL_USER_LAND_ASSETS,
  GET_INDIVIDUAL_USER_LAND_ASSETS_SUCCESS,
  GET_INDIVIDUAL_USER_LAND_ASSETS_FAILED,
  GET_USER_LAND_ASSET_TRANSACTION,
  GET_USER_LAND_ASSET_TRANSACTION_SUCCESS,
  GET_USER_LAND_ASSET_TRANSACTION_FAILED,

  GET_BP_ADMIN_HOME_DATA,
  GET_BP_ADMIN_HOME_DATA_SUCCESS,
  GET_BP_ADMIN_HOME_DATA_FAILED,
  GET_BP_ADMIN_SETTINGS,
  GET_BP_ADMIN_SETTINGS_SUCCESS,
  GET_BP_ADMIN_SETTINGS_FAILED,
  UPDATE_BP_SETTINGS,
  UPDATE_BP_SETTINGS_SUCCESS,
  UPDATE_BP_SETTINGS_FAILED,
  GET_LAND_ASSETS,
  GET_LAND_ASSETS_SUCCESS,
  GET_LAND_ASSETS_FAILED,
  ADD_LAND_ASSETS,
  ADD_LAND_ASSETS_SUCCESS,
  ADD_LAND_ASSETS_FAILED,
  GET_LAND_ASSET_TRANSACTIONS,
  GET_LAND_ASSET_TRANSACTIONS_SUCCESS,
  GET_LAND_ASSET_TRANSACTIONS_FAILED,
} from './constants'

import { IBITPLOT } from '../../interfaces/bit-plot'
import { DEFAULT_BIT_PLOT } from './bit-plot'

// import {  getAllBitPlotMeTransactions } from './utility'

const initialState: IBITPLOT = DEFAULT_BIT_PLOT

export const bitPlotReducer = (
  state: IBITPLOT = initialState,
  action: BitplotActionConstants
) => {
  switch (action.type) {
    case GET_BP_USER_HOME_DATA:
      return { ...state, get_user_home_data_loading: true }
    case GET_BP_USER_HOME_DATA_SUCCESS:
      return {
        ...state,
        get_user_home_data_loading: false,
        get_user_home_data: action.payload.data.data
      }
    case GET_BP_USER_HOME_DATA_FAILED:
      return {
        ...state,
        get_user_home_data_loading: false,
        error: { get_user_home_data_error: action.payload }
      }

    case GET_BP_USER_SETTINGS:
      return { ...state, get_user_settings_loading: true }
    case GET_BP_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        get_user_settings_loading: false,
        get_user_settings: action.payload.data.data
      }
    case GET_BP_USER_SETTINGS_FAILED:
      return {
        ...state,
        get_user_settings_loading: false,
        error: { get_user_settings_error: action.payload }
      }

    case BUY_LAND_ASSET:
      return { ...state, buy_land_asset_loading: true }
    case BUY_LAND_ASSET_SUCCESS:
      return {
        ...state,
       buy_land_asset_loading: false,
       buy_land_asset: action.payload.data.data
      }
    case BUY_LAND_ASSET_FAILED:
      return {
        ...state,
        buy_land_asset_loading: false,
        error: { buy_land_asset_error: action.payload }
      }

    case GET_USER_LAND_ASSETS:
      return { ...state, get_user_land_asset_loading: true }
    case GET_USER_LAND_ASSETS_SUCCESS:
      return {
        ...state,
        get_user_land_asset_loading: false,
        get_user_land_asset: action.payload.data.data,
        get_user_land_asset_pagination: action.payload.data.pagination
      }
    case GET_USER_LAND_ASSETS_FAILED:
      return {
        ...state,
       get_user_land_asset_loading: false,
        error: {get_user_land_asset_error: action.payload }
      }

    case GET_INDIVIDUAL_USER_LAND_ASSETS:
      return { ...state, get_individual_user_land_asset_loading: true }
    case GET_INDIVIDUAL_USER_LAND_ASSETS_SUCCESS:
      return {
        ...state,
        get_individual_user_land_asset_loading: false,
        get_individual_user_land_asset: action.payload.data.data,
        get_individual_user_land_asset_pagination: action.payload.data.pagination
      }
    case GET_INDIVIDUAL_USER_LAND_ASSETS_FAILED:
      return {
        ...state,
        get_individual_user_land_asset_loading: false,
        error: { get_individual_user_land_asset_error: action.payload }
      }

    case GET_USER_LAND_ASSET_TRANSACTION:
      return { ...state, get_user_land_asset_transaction_loading: true }
    case GET_USER_LAND_ASSET_TRANSACTION_SUCCESS:
      return {
        ...state,
        get_user_land_asset_transaction: action.payload.data.data,
        get_user_land_asset_transaction_pagination: action.payload.data.pagination,
        get_user_land_asset_transaction_loading: false
      }
    case GET_USER_LAND_ASSET_TRANSACTION_FAILED:
      return {
        ...state,
        get_user_land_asset_transaction_loading: false,
        error: { get_user_land_asset_transaction_error: action.payload }
      }

    case GET_BP_ADMIN_HOME_DATA:
      return { ...state, get_admin_home_data_loading: true }
    case GET_BP_ADMIN_HOME_DATA_SUCCESS:
      return {
        ...state,
       get_admin_home_data_loading: false,
       get_admin_home_data: action.payload.data.data
      }
    case GET_BP_ADMIN_HOME_DATA_FAILED:
      return {
        ...state,
       get_admin_home_data_loading: false,
        error: {get_admin_home_data_error: action.payload }
      }

   case GET_BP_ADMIN_SETTINGS:
      return { ...state, get_admin_settings_loading: true }
   case GET_BP_ADMIN_SETTINGS_SUCCESS:
      return {
        ...state,
        get_admin_settings: action.payload.data.data,
        get_admin_settings_loading: false
      }
   case GET_BP_ADMIN_SETTINGS_FAILED:
      return {
        ...state,
        get_admin_settings_loading: false,
        error: { get_admin_settings_error: action.payload }
      }

    case UPDATE_BP_SETTINGS:
      return { ...state, update_settings_loading: true }
    case UPDATE_BP_SETTINGS_SUCCESS:
      return {
        ...state,
        update_settings: action.payload.data,
        update_settings_loading: false
      }
    case UPDATE_BP_SETTINGS_FAILED:
      return {
        ...state,
        update_settings_loading: false,
        error: { update_settings_error: action.payload }
      }

    case GET_LAND_ASSETS:
      return { ...state, get_land_assets_loading: true }
    case GET_LAND_ASSETS_SUCCESS:
      return {
        ...state,
       get_land_assets: action.payload.data.data,
       get_land_assets_pagination: action.payload.data.pagination,
       get_land_assets_loading: false
      }
    case GET_LAND_ASSETS_FAILED:
      return {
        ...state,
        get_land_assets_loading: false,
        error: { get_land_assets_error: action.payload }
      }

    case ADD_LAND_ASSETS:
      return { ...state, add_land_assets_loading: true }
    case ADD_LAND_ASSETS_SUCCESS:
      return {
        ...state,
        add_land_assets: action.payload.data,
        add_land_assets_loading: false
      }
    case ADD_LAND_ASSETS_FAILED:
      return {
        ...state,
        add_land_assets_loading: false,
        error: { add_land_assets_error: action.payload }
      }


    case GET_LAND_ASSET_TRANSACTIONS:
      return { ...state, get_land_asset_transactions_loading: true }
    case GET_LAND_ASSET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        get_land_asset_transactions: action.payload.data.data,
        get_land_asset_transactions_pagination: action.payload.data.pagination,
        get_land_asset_transactions_loading: false
      }
    case GET_LAND_ASSET_TRANSACTIONS_FAILED:
      return {
        ...state,
        get_land_asset_transactions_loading: false,
        error: { get_land_asset_transactions_error: action.payload }
      }

    default:
      return state
  }
}
